<template>
  <div v-if="loading">
    <oil-cap
        :title="'нефтебазы'.toUpperCase()"
        :buttons="[
                  {
                    route: 'terminal',
                    name: 'добавить базу'
                  }
        ]"
    />
    <v-divider class="my-2"/>
    <oil-table
        :items="terminals"
        :paginate='count'
        @paginateAction="terminalPaginate"
        :keys="[
          {text:'название' ,value:'Name'},
          {text:'адрес',value:'Address'},
          {text:'ответственное лицо',value:'ResponsiblePerson'},
          {text:'договор',value:'ContractNumber'},
          {text:'статус',value:'Status'},
          {text:'',value:'UPDATE_ID'},
          {text:'',value:'DELETE_ID'},
      ]"
    >
      <template v-slot:UPDATE_ID="{value}">
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn v-bind='attrs'
                   v-on='on' icon
                   @click='rowClick(value)'>
              <v-icon color='primary'>
                mdi-pen
              </v-icon>
            </v-btn>
          </template>
          <span>РЕДАКТИ́РОВАТЬ</span>
        </v-tooltip>
      </template>
      <template v-slot:DELETE_ID="{value}">
        <v-row>
          <v-col
              md="6"
              offset-md="3"
          >
            <oil-modal
                :value='value'
                tooltipMessage='УДАЛИТЬ'
                mdiIcon='mdi-delete'
                :accept='deleteTerminal'
            />
          </v-col>
        </v-row>
      </template>
    </oil-table>
  </div>
</template>

<script>
import {terminalService} from "@/services/TerminalService";
import {contractsService} from "~/services/ContractsService";

export default {
  data: () => ({
    loading: false,
    terminals: [],
    count: {
      count: 0
    },
  }),
  components: {
    OilTable: () => import('@/components/helper/oil.table'),
    OilCap: () => import('@/components/helper/oil.cap'),
    OilModal: () => import('@/components/helper/form/oil.delete.modal'),
  },
  async created() {
    await this.terminalPaginate((this.currentPage - 1) * 10);
    this.loading = true
  },
  methods: {
    async deleteTerminal(id) {
      const response = await terminalService.delete(id)
      const isDelete = response.data
      if (isDelete) {
        const terminal = this.terminals.find(({Id}) => Id === id)
        const index = this.terminals.indexOf(terminal)
        this.terminals.splice(index, 1)
        this.$notify({
          group: 'mgs',
          type: 'success',
          title: `Нефтебаза удачно удалена`
        })
      }
    },
    async terminalPaginate(page) {
      const terminals = await terminalService.paginate(page)
      const {count, dates} = terminals.data
      this.count.count = count
      this.terminals = dates?.map(m => {
        return {
          ...m,
          DELETE_ID: m.Id,
          UPDATE_ID: m.Id,
          Name: m.Name,
          Address: m.Address,
          ResponsiblePerson: m.ResponsiblePerson,
          ContractNumber: m.ContractNumber,
          Status: m.Status
        }
      })
    },
    rowClick(Id) {
      this.$router.push(`/terminal/${Id}`)
    }
  }
}
</script>
